import React, {Component} from "react";
import {connect} from "react-redux";
import {withStyles} from "material-ui/styles";
import {TagGroup, Tag} from "../ui/react-aria/TagGroup";
import styles from "./JobsViewByListStyles";
import {setJobsViewBy} from "../../redux/actions";
import {TreeNode} from "./models";
import {Key} from "react-aria-components";

class JobsViewByList extends Component<any> {
  removeTreeNodes(keys: Key[]) {
    const {jobsViewBy, setJobsViewBy} = this.props;

    const treeNodes = [...jobsViewBy];
    keys.forEach(key => {
      const index = treeNodes.findIndex(i => i.id === key);
      if (index !== -1) {
        treeNodes.splice(index, 1);
      }
    });
    setJobsViewBy(treeNodes);
  }

  getNodeType(type: string): string {
    return type
      .split(/(?=[A-Z])/)
      .map(p => p.charAt(0).toUpperCase() + p.slice(1))
      .join(" ");
  }

  render() {
    const {classes, jobsViewBy, jobsViewByActive} = this.props;
    const isJobsViewBy = jobsViewByActive && jobsViewBy && jobsViewBy.length !== 0;

    return <React.Fragment>
        {isJobsViewBy && <div className={classes.root}>
          <TagGroup
            label="Viewing By:"
            items={jobsViewBy}
            onRemove={(keys) => this.removeTreeNodes(Array.from(keys))}
            renderEmptyState={() => <div>No filter</div>}>
            {(item: TreeNode) => <Tag
              textValue={item.title}>{this.getNodeType(item.type)}: {item.title}</Tag>}
          </TagGroup>
        </div>}
      </React.Fragment>;
  }
}

const mapStateToProps = (state: any) => ({
  jobsViewBy: state.jobViewByReducer.jobsViewBy,
  jobsViewByActive: state.jobViewByReducer.active,
  ...state
});

const mapDispatchToProps = (dispatch: any, props: any) => ({
  setJobsViewBy: (treeNodes: TreeNode[]) => {
    dispatch(setJobsViewBy(treeNodes));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)
(withStyles(styles)(JobsViewByList));
